import "./MyContact.scss"
import FeedbackForm from "../../../components/FeedbackForm/FeedbackForm"
import { git_icon, insta_icon, email_icon, tel_icon } from "../../../service/image"


const MyContact = () => {

    
return(

    <section className="my-contact">

        <div className="container">

        <h3>Contact <span>Me</span> </h3>
    <div className="my-contact__items ">
        <div className="my-contact__item">
           <FeedbackForm />
        </div>

        <div className="my-contact__item">
            <div className="my-contact__item element">
               <a href="https://github.com/eriksw2364939546">
               <img src={git_icon} alt="Git icon" />
               </a>

               <a href="https://www.instagram.com/e_r_i_k_inst/">
               <img src={insta_icon} alt="Instagram icon" />
               </a>

            </div>

            <div className="my-contact__item element">
               <a href="mailto:goodprogramwork@gmail.com">
                <img src={email_icon} alt="E-mail icon" />
               </a>

               <a href="#">
                <img src={tel_icon} alt="Telephon icon" />
                
               </a>
            </div>
        </div>


    </div>

        </div>



</section>
)
}


export default MyContact